export const Languages = {
    Spanish: {

        /*Footer*/

        OurSocialNetworks: "Nuestras Redes",
        Legal: "Legal",
        TermsAndConditions: "Terminos y condiciones",
        PrivacyPolicies: "Políticas de privacidad",
        OfficialCollaborators: "Con la colaboración oficial",
        LesFalles: "Las Fallas, Patrimonio Inmaterial de la Humanidad por la UNESCO",

        /*Inicio*/

        GeneralInformation: 'Información General',
        ComissionNumber: "Comisión Nº",
        CasalFallero: "Casal Fallero",
        Monument: "Monumento",
        Founded: "Fundada",
        NumberOfFalleros: "Numero de falleros",
        Sector: "Sector",
        Section: "Sección",
        Contact: "Contacto",
        StayInformed: "Manténte Informado",
        LatestNews: "Últimas Noticias",
        NextEvent: "Próximo Evento",
        ViewMoreNews: "Ver más noticias",
        ViewMoreEvents: "Ver más eventos",
        SeeOnInstagram: "Ver en Instagram",
        NoUpcomingEvents: "No hay eventos próximos",

        /*LogoHeader*/

        PlazaRodrigoFalla: "Falla Plaza Rodrigo",

        /*NavBar*/

        Falleros: "Falleros",
        Historical: "Historico",
        OurHistory: "Nuestra historia",
        Llibret: "Llibret",
        PreviousRepresentatives: "Representantes anteriores",

        Galery: "Galeria",
        Photos: "Fotos",
        FalleroArt: "Arte fallero",
        AwardsAndHonours: "Premios y reconocimientos",

        Exercise: "Ejercicio 25-26",
        CurrentRepresentatives: "Representantes actuales",
        News: "Noticias",
        EventsCalendar: "Calendario de eventos",

        Us: "Nosotros",
        ContactForm: "Formulario de contacto",
        Sponsors: "Patrocinadores",
        Downloads: "Descargas",
        RodriguerasSongs: "Canciones Rodrigueras",

        /*Llibrets*/
        OurLlibrets: "Nuestros Llibrets",

        /* Inicio de Sesion */
        LogIn: "Iniciar Sesión",
        IDFallero: "ID Fallero",
        Password: "Contraseña",
        GetIn: "Entrar",
        ErrorMessageLogin: 'Usuario o contraseña incorrectos.',
        SuccessMessageLogin: 'Bienvenido Rodriguero 🧡',
        Note: "Nota",
        NoteInstructions: "El ID de Fallero es su DNI completo con letra en mayúscula. La contraseña predeterminada consta de las tres primeras letras de su primer apellido y su fecha de nacimiento en formato DDMMYY.",
        Example: "Ejemplo",
        ExamplePassword: "Si su apellido es García y nació el 14-04-1969, su contraseña será: gar140469.",


        /* Premios y reconocimientos */
        AwardsHistory: 'Historial de premios',

        /*Noticias*/
        LastNews: 'Últimas Noticias',
        SeeOnInstagram: 'Ver en Instagram',
        LoadMoreNews: 'Cargar más noticias',


        /* Representantes */
        President: 'Presidente',
        FalleraMayor: 'Fallera Mayor',
        ChildrensPresident: 'Presidente Infantil',
        ChildrensPresidentF: 'Presidenta Infantil',
        ChildrensFalleraMayor: 'Fallera Mayor Infantil',
        ChildrensRepresentatives: 'Representantes Infantiles',
        Representatives: 'Representantes',

        /* Representantes Actuales*/
        OurRepresentantes: 'Nuestros Representantes',

        /* Terminos Y Condiciones */
        TermsandConditionsTitle: 'Términos Y Condiciones',
        TermsandConditionsP1: 'Estos términos y condiciones ("Términos") rigen el uso de la página web de la Falla Plaza Rodrigo de Puerto de Sagunto, Valencia ("la Falla", "nosotros", "nuestro" o "el sitio web"). Al acceder y utilizar este sitio web, usted acepta cumplir con estos términos. Si no está de acuerdo con alguno de estos términos, por favor absténgase de utilizar este sitio.',
        UseOfTheSite: 'Uso del Sitio',
        TermsandConditionsP2: 'Usted acepta utilizar este sitio web solo para fines legales y de acuerdo con estos términos',
        TermsandConditionsP3: 'Usted es responsable de mantener la confidencialidad de cualquier información de inicio de sesión y de todas las actividades que ocurran bajo su cuenta.',
        IntellectualProperty: 'Propiedad Intelectual',
        TermsandConditionsP4: 'Todo el contenido y los materiales disponibles en este sitio web, incluidos, entre otros, textos, gráficos, logotipos, imágenes y software, están protegidos por derechos de autor u otros derechos de propiedad intelectual.',
        TermsandConditionsP5: 'Usted acepta respetar todos los avisos de derechos de autor y otras restricciones contenidas en dicho contenido y materiales.',
        LimitationOfLiability: 'Limitación de Responsabilidad',
        TermsandConditionsP6: 'La Falla no será responsable de ningún daño directo, indirecto, incidental, especial, consecuencial o punitivo que surja del uso de este sitio web o de cualquier contenido disponible en él.',
        TermsandConditionsP7: 'Este sitio web se proporciona "tal cual" y "según disponibilidad", sin garantías de ningún tipo, ya sean expresas o implícitas.',
        LinksToThirdParties: 'Enlaces a Terceros',
        TermsandConditionsP8: 'Este sitio web puede contener enlaces a sitios web de terceros que no están bajo el control de la Falla.',
        TermsandConditionsP9: 'La Falla no se hace responsable de la precisión, el contenido, las políticas de privacidad u otras prácticas de ningún sitio web de terceros.',
        Modifications: 'Modificaciones',
        TermsandConditionsP10: 'La Falla se reserva el derecho de modificar o suspender, temporal o permanentemente, este sitio web o cualquier parte de él, con o sin previo aviso.',
        TermsandConditionsP11: 'Usted acepta que la Falla no será responsable ante usted ni ante ningún tercero por cualquier modificación, suspensión o interrupción del sitio web.',
        JurisdictionAndApplicableLaw: 'Jurisdicción y Ley Aplicable',
        TermsandConditionsP12: 'Estos términos se regirán e interpretarán de acuerdo con las leyes de España.',
        TermsandConditionsP13: 'Usted acepta someterse a la jurisdicción exclusiva de los tribunales de España para resolver cualquier disputa que surja en relación con estos términos o el uso de este sitio web.',
        LastUpdate: 'Última actualización',
        TermsandConditionsP14: 'Estos términos fueron actualizados por última vez el: 03/04/2024.',

        /*Politica De Privacidad */
        PrivacyPolicyP1: 'Esta política de privacidad describe cómo la Falla Plaza Rodrigo de Puerto de Sagunto, Valencia ("nosotros", "nuestro", o "la Falla") recopila, utiliza y protege la información personal que recopilamos a través de nuestro sitio web.',
        InformationGathering: 'Recopilación de Información',
        PrivacyPolicyP2: 'La Falla recopila información personal proporcionada voluntariamente por los usuarios, como nombres, direcciones de correo electrónico y números de teléfono, a través de formularios de contacto y otros medios similares.',
        PrivacyPolicyP3: 'También recopilamos información automáticamente a través del uso de cookies y otras tecnologías de seguimiento para mejorar la experiencia del usuario y comprender cómo se utiliza nuestro sitio web.',
        UseOfInformation: 'Uso de la Información',
        PrivacyPolicyP4: 'Utilizamos la información recopilada para responder a consultas, proporcionar servicios solicitados y comunicarnos con los usuarios.',
        PrivacyPolicyP5: 'La información también puede ser utilizada para mejorar nuestro sitio web, personalizar la experiencia del usuario y proporcionar contenido relevante.',
        PrivacyPolicyP6: 'No compartimos información personal con terceros, excepto cuando sea necesario para cumplir con los propósitos descritos anteriormente o cuando lo exija la ley.',
        InformationProtection: 'Protección de la Información',
        PrivacyPolicyP7: 'La Falla implementa medidas de seguridad para proteger la información personal de los usuarios contra el acceso no autorizado, la alteración, la divulgación o la destrucción.',
        PrivacyPolicyP8: 'Sin embargo, tenga en cuenta que ninguna medida de seguridad en Internet es completamente infalible, y no podemos garantizar la seguridad absoluta de la información transmitida a través de nuestro sitio web.',
        AccessAndControlOfInformation: 'Acceso y Control de la Información',
        PrivacyPolicyP9: 'Los usuarios tienen derecho a acceder, corregir, actualizar o eliminar su información personal en cualquier momento.',
        PrivacyPolicyP10: 'Para hacerlo, pueden comunicarse con nosotros a través de los datos de contacto proporcionados en este sitio web.',
        ChangesToThePrivacyPolicy: 'Cambios en la Política de Privacidad',
        PrivacyPolicyP11: 'La Falla se reserva el derecho de actualizar o modificar esta política de privacidad en cualquier momento.',
        PrivacyPolicyP12: 'Cualquier cambio significativo se comunicará a los usuarios mediante una notificación en nuestro sitio web o por otros medios apropiados.',
        PrivacyPolicyP13: 'Al utilizar este sitio web, usted acepta los términos de esta política de privacidad. Si no está de acuerdo con estos términos, por favor absténgase de utilizar nuestro sitio.',
        PrivacyPolicyP14: 'Para cualquier pregunta o inquietud sobre esta política de privacidad, por favor contáctenos a través de los datos de contacto proporcionados en nuestro sitio web o a traves de este correo electronico: ',
        FallaEmail: 'fallaplazarodrigo@gmail.com',
        PrivacyPolicyP15: 'Última actualización: 03/04/2024',

        /* Arte Fallero*/

        SketchesOfOurArtists: 'Bocetos de Nuestros Artistas',
        Artist: 'Artista',
        Motto: 'Lema',

        /*Claendario de eventos */

        RodrigoEventsCalendar: 'Calendario De Eventos Rodrigo',
        UpcomingEvents: 'Próximos Eventos',
        allDay: 'Todo el día',
        previous: '<',
        next: '>',
        today: 'Hoy',
        month: 'Mes',
        week: 'Semana',
        day: 'Día',
        agenda: 'Agenda',
        date: 'Fecha',
        time: 'Hora',
        event: 'Evento',
        Location: 'Ubicación',

        /* Encuestas */

        Description: 'Descripción',
        Date: 'Fecha',
        Hour: 'Hora',
        Place: 'Lugar',
        Surveys: 'Encuestas',
        AnswerSurvey: 'Contestar encuestas',
        SingUp: 'Apuntarse',
        ManageSurveys: 'Gestionar Encuestas',

        SuccessMessageSurveys: 'Te has apuntado a la encuesta',
        ErrorMessageAnswerSurveys: 'Error apuntándose a la encuesta',
        SignedUpMessage: "Estás apuntado a esta encuesta",

        Question: "Pregunta",
        Answer: "Respuesta",
        ErrorMessageDeleteVote: "Ha ocurrido un error al intentar cancelar tu voto.",
        SuccessMessageDeleteVote: "Tu encuesta ha sido cancelada con éxito.",
        CancelSurvey: "Cancelar encuesta",

        /* Crear Encuestas */

        SignUpForEventAlone: "Apuntarse a Evento solo",
        CreateQuiz: "Crear Cuestionario",
        Qualification: "Título",
        AddQuestion: "Añadir Pregunta",
        Ask: "Pregunta",
        SelectTheTypeOfResponse: "Seleccione el tipo de respuesta",
        OnlyAnswer: "Única respuesta",
        VariousAnswers: "Varias respuestas",
        TextAnswer: "Pregunta de texto",
        AddOption: "Añadir Opción",
        DeleteLastOption: "Borrar Última Opción",
        Option: "Opción",
        DeleteQuestion: "Borrar Pregunta",
        Send: "Enviar",
        Update:"Actualizar",

        ErrorMessageCreateEvent: "Ha habido algun error inesperado",
        SuccessMessageCreateEvent: "Encuesta creada correctamente",

        /* Lista de Usuarios */

        UserList: "Lista de Usuarios",
        Name: "Nombre",
        Surname: "Apellido",
        DNI: "DNI",
        Partners: "Socios",
        Phone: "Telefono",
        Email: "Email",
        Rewards: "Recompensas",
        Birthdate: "Fecha de Nacimiento",
        ChildrenOrGuardiansOf: "Hijos o Tutores de",
        Range: "Rango",
        Age: 'Edad',
        Actions: "Acciones",

        /* Crear Usuarios */

        CreateUser: "Crear nuevo usuario",
        ErrorMessageCreateUser: 'Credenciales del usuario repetidas o con algun fallo.',
        SuccessMessageCreateUser: 'Usuario creado correctamente',
        Return: "Volver",

        /* NavPerfil */

        Profile: "Perfil",
        Notifications: "Notificaciones",
        Surveys: "Encuestas",
        Administration: "Administración",

        Users: "Usuarios",
        CreateNotifications: "Crear Notificaciones",
        CreateSurveys: "Crear Encuestas",
        EditSurvey: "Editar Encuesta",
        EditNotification: "Editar Notificación",

        /* Contestar Encuestas */

        Charging: 'Cargando...',
        SuccessMessageAnswerSurveys: 'Encuesta enviada con éxito',
        ErrorMessageAnswerSurveys: 'Error al enviar la encuesta',

        /* Gestionar Encuestas */

        TargetedUsers: 'Usuarios Apuntados',
        ExportToExcel: 'Exportar a Excel',
        ExportToPDF: 'Exportar a PDF',
        ThereAreNoRegisteredUsers: 'No hay usuarios apuntados',

        /* Crear Notificaciones */

        CreateNotification: 'Crear Notificación',
        Recipients: 'Destinatarios',
        AllUsers: 'Todos los usuarios',
        Adults: 'Adultos',
        Youth: 'Juveniles',
        Children: 'Infantiles',
        LinkedSurvey: 'Encuesta vinculada',
        SelectSurvey: 'Seleccione encuesta',
        SelectASurvey: 'Seleccione una encuesta',
        CreateNotification: 'Crear Notificación',
        SuccessMessageCreateNotification: 'Notificación creada con éxito',
        ErrorMessageCreateNotification: 'Error al crear la notificación',

        /*Patrocinadores*/

        Publicidad: "Publicidad",
        Generate: 'Generar QR',

        /*Subir Imagenes*/

        SuccessMessageUploadImage: 'Imagen subida con éxito',
        ImageMissing: 'Imagen incompleta o datos faltantes.',
        ErrorMessageUploadImage: 'Error al subir la imagen',
        ImageManager: 'Administrar imágenes',
        ImageManagerDescription: 'Gestiona el contenido visual de cada ejercicio.',
        HomeContent: 'Inicio y portada',
        HistoricalContent: 'Contenido histórico',
        RepresentativesCover: 'Portada de representantes',
        CoverDescription: 'Imagen editorial de la portada. El archivo anterior se conserva.',
        MainSponsors: 'Patrocinadores principales',
        SpecialCollaborators: 'Colaboradores especiales',
        SponsorDescription: 'Gestiona el orden, estado y logo sin necesidad de publicar una nueva versión de la web.',
        SelectYear: 'Selecciona un año', SelectCategory: 'Selecciona una categoría',
        Sketches: 'Bocetos', Llibrets: 'Llibrets', Awards: 'Premios',
        PresidentInfantil: 'Presidente Infantil', FalleraMayorInfantil: 'Fallera Mayor Infantil',
        Major: 'Mayor', Infant: 'Infantil', Link: 'Enlace', Order: 'Orden', Type: 'Tipo', Active: 'Activo', Inactive: 'Inactivo',
        CurrentImage: 'Imagen actual', NoImage: 'Sin imagen', AddImage: 'Añadir imagen', ChangeImage: 'Cambiar imagen', ReplaceImage: 'Reemplazar imagen',
        EditData: 'Editar datos', Save: 'Guardar', Cancel: 'Cancelar', Remove: 'Quitar', MoveUp: 'Subir', MoveDown: 'Bajar',
        AddSponsor: 'Añadir patrocinador o colaborador', MainSponsor: 'Patrocinador principal', SpecialCollaborator: 'Colaborador especial',
        Loading: 'Cargando…', Saving: 'Guardando…', Saved: 'Cambios guardados.', EmptyContent: 'No hay contenido para este año.',
        SelectImage: 'Selecciona una imagen', ImagePreview: 'Vista previa de la imagen seleccionada',
        DetachTitle: 'Quitar imagen del contenido', DetachMessage: 'Esta imagen dejará de aparecer, pero el archivo original se conservará.',
        ReplaceTitle: 'Confirmar reemplazo', ReplaceMessage: 'La nueva imagen se mostrará al guardar. El archivo anterior se conservará.',
        Confirm: 'Confirmar', AwardsText: 'Premios y reconocimientos', AddAwardImage: 'Añadir imagen de premios',
        LlibretUrl: 'Enlace del llibret', PhotoDescription: 'Descripción',
        Map: 'Mapa', InstagramVideo: 'Vídeo de Instagram', InstagramPost: 'Publicación de Instagram',
        FaqTitle: 'Preguntas frecuentes', FaqQuestion1: '¿Qué es una falla?', FaqAnswer1: 'Una falla es una asociación cultural que mantiene vivas las tradiciones valencianas y organiza actividades durante todo el año.',
        FaqQuestion2: '¿Cómo me puedo apuntar a la falla?', FaqAnswer2: 'Puedes acercarte al casal fallero y preguntar por la disponibilidad para unirte a la comisión.',
        FaqQuestion3: '¿Es obligatorio vestirse en los actos?', FaqAnswer3: 'No es obligatorio, aunque es recomendable para mantener viva la tradición.',
        FaqQuestion4: '¿Se realizan más actos aparte de las Fallas?', FaqAnswer4: 'Sí. La comisión organiza actividades deportivas y culturales durante todo el año.',

        /*Editar Usuarios*/

        UpdateProfile: 'Actualizar Perfil',
        ConfirmPassword: 'Confirmar Contraseña',
        NewPassword: 'Nueva Contraseña',
        ChangePassword: 'Configura contrseña',

        EmailRequiredForPasswordChange: "Para cambiar la contraseña, por favor ingresa tu correo electrónico.",
        PasswordMismatch: "Las contraseñas no coinciden.",
        EmailRequired: "El correo electrónico es obligatorio.",
        EmailMismatch: "El correo electrónico no coincide.",
        ProfileUpdated: "Perfil actualizado con éxito.",
        ErrorUpdatingProfile: "Error al actualizar el perfil.",
        UnexpectedError: "Error inesperado, por favor intente nuevamente.",
        RewardsInstructions: "Para los socios y recompensas, se deben separar con una coma. Ejemplo: Pepe, Luis"


    },
    Valencian: {

        /*Footer*/

        OurSocialNetworks: "Les nostres Xarxes",
        Legal: "Legal",
        TermsAndConditions: "Termes i condicions",
        PrivacyPolicies: "Polítiques de privacitat",
        OfficialCollaborators: "Amb la col·laboració oficial",
        LesFalles: "Les Falles, Patrimoni Immaterial de la Humanitat per la UNESCO",

        /*Inicio*/

        GeneralInformation: 'Informació General',
        ComissionNumber: "Comissió Nº",
        CasalFallero: "Casal Faller",
        Monument: "Monument",
        Founded: "Fundada",
        NumberOfFalleros: "Numere de fallers",
        Sector: "Sector",
        Section: "Secció",
        Contact: "Contacte",
        StayInformed: "Mantingues-te Informat",
        LatestNews: "Últimes Notícies",
        NextEvent: "Pròxim Esdeveniment",
        ViewMoreNews: "Veure més notícies",
        ViewMoreEvents: "Veure més esdeveniments",
        SeeOnInstagram: "Veure en Instagram",
        NoUpcomingEvents: "No hi ha esdeveniments pròxims",

        /*LogoHeader*/

        PlazaRodrigoFalla: "Falla Plaça Rodrigo",

        /*NavBar*/

        Falleros: "Fallers",

        Historical: "Històric",
        OurHistory: "La nostra història",
        Llibret: "Llibret",
        PreviousRepresentatives: "Representants anteriors",

        Galery: "Galeria",
        Photos: "Fotos",
        FalleroArt: "Art faller",
        AwardsAndHonours: "Premis i reconeixements",

        Exercise: "Exercici 25-26",
        CurrentRepresentatives: "Representants actuals",
        News: "Notícies",
        EventsCalendar: "Calendari d'esdeveniments",

        Us: "Nosaltres",
        ContactForm: "Formulari de contacte",
        Sponsors: "Patrocinadors",
        Downloads: "Descàrregues",
        RodriguerasSongs: "Cançons Rodrigueras",

        /*Llibrets*/

        OurLlibrets: "Els nostres Llibrets",

        /* Inicio de Sesion */

        LogIn: "Iniciar Sessió",
        IDFallero: "ID Faller",
        Password: "Contrasenya",
        GetIn: "Entrar",
        ErrorMessageLogin: 'Usuari o contrasenya incorrectes.',
        SuccessMessageLogin: 'Benvingut Rodriguero 🧡',
        ErrorMessageLogin: "L'ID de Faller o la contrasenya són incorrectes.",
        SuccessMessageLogin: "Sessió iniciada amb èxit. Redirigint...",
        Note: "Nota",
        NoteInstructions: "L'ID de Faller és el seu DNI complet amb lletra en majúscules. La contrasenya predeterminada consta de les tres primeres lletres del seu primer cognom i la seva data de naixement en format DDMMYY.",
        Example: "Exemple",
        ExamplePassword: "Si el seu cognom és García i va nàixer el 14-04-1969, la seva contrasenya serà: gar140469.",


        /* Premios y reconocimientos */

        AwardsHistory: 'Historial de premis',

        /*Noticias*/

        LastNews: 'Ultimes Noticies',
        SeeOnInstagram: 'Veure en Instagram',
        LoadMoreNews: 'Carregar més notícies',

        /* Representantes */

        President: 'President',
        FalleraMayor: 'Fallera Major',
        ChildrensPresident: 'President Infantil',
        ChildrensPresidentF: 'Presidenta Infantil',
        ChildrensFalleraMayor: 'Fallera Major Infantil',
        ChildrensRepresentatives: 'Representants Infantils',
        Representatives: 'Representants',

        /* Representantes Actuales*/

        OurRepresentantes: 'Els Nostres Representants',

        /* Terminos Y Condiciones */

        TermsandConditionsP1: 'Estos termes i condicions ("Termes") regixen l´ús de la pàgina web de la Falla Plaza Rodrigo de Port de Sagunt, València ("la Falla", "nosaltres", "nostre" o "el lloc web"). En accedir i utilitzar este lloc web, vosté accepta complir amb estos termes. Si no està d´acord amb algun d´estos termes, per favor abstinga´s d´utilitzar este lloc.',
        UseOfTheSite: 'Ús del Lloc',
        TermsandConditionsP2: 'Vosté accepta utilitzar este lloc web només per a fins legals i d´acord amb estos termes.',
        TermsandConditionsP3: 'Vosté és responsable de mantindre la confidencialitat de qualsevol informació d´inici de sessió i de totes les activitats que ocórreguen sota el seu compte.',
        IntellectualProperty: 'Propietat Intel·lectual',
        TermsandConditionsP4: 'Tot el contingut i els materials disponibles en este lloc web, inclosos, entre altres, textos, gràfics, logotips, imatges i programari, estan protegits per drets d´autor o altres drets de propietat intel·lectual.',
        TermsandConditionsP5: 'Vosté accepta respectar tots els avisos de drets d´autor i altres restriccions contingudes en este contingut i materials.',
        LimitationOfLiability: 'Limitació de Responsabilitat',
        TermsandConditionsP6: 'La Falla no serà responsable de cap mal directe, indirecte, incidental, especial, *consecuencial o punitiu que sorgisca de l´ús d´este lloc web o de qualsevol contingut disponible en ell.',
        TermsandConditionsP7: 'Este lloc web es proporciona "tal qual" i "segons disponibilitat", sense garanties de cap mena, ja siguen expresses o implícites.',
        LinksToThirdParties: 'Enllaços a Tercers',
        TermsandConditionsP8: 'Este lloc web pot contindre enllaços a llocs web de tercers que no estan sota el control de la Falla.',
        TermsandConditionsP9: 'La Falla no es fa responsable de la precisió, el contingut, les polítiques de privacitat o altres pràctiques de cap lloc web de tercers.',
        Modifications: 'Modificacions',
        TermsandConditionsP10: 'La Falla es reserva el dret de modificar o suspendre, temporal o permanentment, este lloc web o qualsevol part d´ell, amb o sense previ avís.',
        TermsandConditionsP11: 'Vosté accepta que la Falla no serà responsable davant vosté ni davant cap tercer per qualsevol modificació, suspensió o interrupció del lloc web.',
        JurisdictionAndApplicableLaw: 'Jurisdicció i Llei Aplicable',
        TermsandConditionsP12: 'Estos termes es regiran i interpretaran d´acord amb les lleis d´Espanya.',
        TermsandConditionsP13: 'Vosté accepta sotmetre´s a la jurisdicció exclusiva dels tribunals d´Espanya per a resoldre qualsevol disputa que sorgisca en relació amb estos termes o l´ús d´este lloc web.',
        LastUpdate: 'Última actualització',
        TermsandConditionsP14: 'Estos termes van ser actualitzats per última vegada el: 03/04/2024.',

        /*Politica De Privacidad */

        PrivacyPolicyP1: 'Esta política de privacitat descriu com la Falla Plaza Rodrigo de Port de Sagunt, València ("nosaltres", "nostre", o "la Falla") recopila, utilitza i protegix la informació personal que recopilem a través del nostre lloc web',
        InformationGathering: 'Recopilació d´Informació',
        PrivacyPolicyP2: 'La Falla recopila informació personal proporcionada voluntàriament pels usuaris, com a noms, adreces de correu electrònic i números de telèfon, a través de formularis de contacte i altres mitjans similars.',
        PrivacyPolicyP3: 'També recopilem informació automàticament a través de l´ús de cookies i altres tecnologies de seguiment per a millorar l´experiència de l´usuari i comprendre com s´utilitza el nostre lloc web.',
        UseOfInformation: 'Ús de la Informació',
        PrivacyPolicyP4: 'Utilitzem la informació recopilada per a respondre a consultes, proporcionar servicis sol·licitats i comunicar-nos amb els usuaris.',
        PrivacyPolicyP5: 'La informació també pot ser utilitzada per a millorar el nostre lloc web, personalitzar l´experiència de l´usuari i proporcionar contingut rellevant.',
        PrivacyPolicyP6: 'No compartim informació personal amb tercers, excepte quan siga necessari per a complir amb els propòsits descrits anteriorment o quan ho exigisca la llei.',
        InformationProtection: 'Protecció de la Informació',
        PrivacyPolicyP7: 'La Falla implementa mesures de seguretat per a protegir la informació personal dels usuaris contra l´accés no autoritzat, l´alteració, la divulgació o la destrucció.',
        PrivacyPolicyP8: 'No obstant això, tinga en compte que cap mesura de seguretat en Internet és completament infal·lible, i no podem garantir la seguretat absoluta de la informació transmesa a través del nostre lloc web.',
        AccessAndControlOfInformation: 'Accés i Control de la Informació',
        PrivacyPolicyP9: 'Els usuaris tenen dret a accedir, corregir, actualitzar o eliminar la seua informació personal en qualsevol moment.',
        PrivacyPolicyP10: 'Per a fer-ho, poden comunicar-se amb nosaltres a través de les dades de contacte proporcionats en este lloc web.',
        ChangesToThePrivacyPolicy: 'Canvis en la Política de Privacitat',
        PrivacyPolicyP11: 'La Falla es reserva el dret d´actualitzar o modificar esta política de privacitat en qualsevol moment.',
        PrivacyPolicyP12: 'Qualsevol canvi significatiu es comunicarà als usuaris mitjançant una notificació en el nostre lloc web o per altres mitjans apropiats.',
        PrivacyPolicyP13: 'En utilitzar este lloc web, vosté accepta els termes d´esta política de privacitat. Si no està d´acord amb estos termes, per favor abstinga´s d´utilitzar el nostre lloc.',
        PrivacyPolicyP14: 'Per a qualsevol pregunta o inquietud sobre esta política de privacitat, per favor contacte´ns a través de les dades de contacte proporcionats en el nostre lloc web o a través d´este correu electrònic: ',
        FallaEmail: 'fallaplazarodrigo@gmail.com',
        PrivacyPolicyP15: 'Última actualització: 03/04/2024',

        /* Arte Fallero*/

        SketchesOfOurArtists: 'Esbossos dels Nostres Artistes',
        Artist: 'Artista',
        Motto: 'Lema',


        /*Claendario de eventos */

        RodrigoEventsCalendar: 'Calendari d´Esdeveniments Rodrigo',
        UpcomingEvents: 'Pròxims esdeveniments',
        Location: 'Ubicació',

        /* Encuestas */

        Description: 'Descripció',
        Date: 'Data',
        Hour: 'Hora',
        Place: 'Lloc',
        Surveys: 'Enquestes',
        AnswerSurvey: 'Contestar enquestes',
        SingUp: 'Apuntar-se',
        ManageSurveys: 'Gestionar Enquestes',

        SuccessMessageSurveys: 'T`has apuntat a l`enquesta',
        ErrorMessageAnswerSurveys: 'Error apuntant-se a l`enquesta',
        SignedUpMessage: "Estàs apuntat a esta enquesta",

        Question: "Pregunta",
        Answer: "Resposta",
        ErrorMessageDeleteVote: "Hi ha hagut un error en intentar cancel·lar el teu vot.",
        SuccessMessageDeleteVote: "La teua enquesta s'ha cancel·lat amb èxit.",
        CancelSurvey: "Cancel·lar enquesta",

        /* Crear Encuestas */

        SignUpForEventAlone: "Apuntar-se a Esdeveniment sol",
        CreateQuiz: "Crear Qüestionari",
        Qualification: "Títol",
        AddQuestion: "Afegir Pregunta",
        Ask: "Pregunta",
        SelectTheTypeOfResponse: "Seleccione el tipus de resposta",
        OnlyAnswer: "Única resposta",
        VariousAnswers: "Diverses respostes",
        TextAnswer: "Pregunta de text",
        AddOption: "Afegir Opció",
        DeleteLastOption: "Esborrar Última Opció",
        Option: "Opció",
        DeleteQuestion: "Esborrar Pregunta",
        Send: "Enviar",
        Update:"Actualitzar",

        ErrorMessageCreateEvent: "Hi ha hagut algun error inesperat",
        SuccessMessageCreateEvent: "Enquesta creada correctament",


        /* Lista de Usuarios */

        UserList: "Llista d'Usuaris",
        Name: "Nom",
        Surname: "Cognom",
        DNI: "DNI",
        Partners: "Socis",
        Phone: "Telèfon",
        Email: "Email",
        Rewards: "Recompenses",
        Birthdate: "Data de Naixement",
        ChildrenOrGuardiansOf: "Fills o Tutors de",
        Range: "Rang",
        Age: 'Edat',
        Actions: "Accions",

        /* Crear Usuarios */

        CreateUser: "Crear nou usuari",
        ErrorMessageCreateUser: 'Credencials de l´usuari repetides o amb alguna fallada',
        SuccessMessageCreateUser: 'Usuari creat correctament',
        Return: "Tornar",

        /* NavPerfil */

        Profile: "Perfil",
        Notifications: "Notificacions",
        Surveys: "Enquestes",
        Administration: "Administració",

        Users: "Usuaris",
        CreateNotifications: "Crear Notificacions",
        CreateSurveys: "Crear Enquestes",
        EditSurvey: "Editar Enquesta",
        EditNotification: "Editar Notificació",
        /* Contestar Encuestas */

        Charging: 'Carregant...',
        SuccessMessageAnswerSurveys: 'Enquesta enviada amb èxit',
        ErrorMessageAnswerSurveys: 'Error en enviar l`enquesta',

        /* Gestionar Encuestas */

        TargetedUsers: 'Usuaris Apuntats',
        ExportToExcel: 'Exportar a Excel',
        ExportToPDF: 'Exportar a PDF',
        ThereAreNoRegisteredUsers: 'No hi ha usuaris apuntats',

        /* Crear Notificaciones */

        CreateNotification: 'Crear Notificació',
        Recipients: 'Destinataris',
        AllUsers: 'Tots els usuaris',
        Adults: 'Adults',
        Youth: 'Juvenils',
        Children: 'Infantils',
        LinkedSurvey: 'Enquesta vinculada',
        SelectSurvey: 'Seleccione enquesta',
        SelectASurvey: 'Seleccione una enquesta',
        SuccessMessageCreateNotification: 'Notificació creada amb èxit',
        ErrorMessageCreateNotification: 'Error en crear la notificació',

        /*Patrocinadores*/

        Publicidad: "Publicitat",
        Generate: 'Generar QR',

        /*Subir Imagenes*/

        SuccessMessageUploadImage: 'Imatge pujada amb èxit',
        ImageMissing: 'Imatge faltant o dades incompletes.',
        ErrorMessageUploadImage: 'Error en pujar la imatge',
        ImageManager: 'Administrar imatges',
        ImageManagerDescription: 'Gestiona el contingut visual de cada exercici.',
        HomeContent: 'Inici i portada',
        HistoricalContent: 'Contingut històric',
        RepresentativesCover: 'Portada de representants',
        CoverDescription: 'Imatge editorial de la portada. L’arxiu anterior es conserva.',
        MainSponsors: 'Patrocinadors principals',
        SpecialCollaborators: 'Col·laboradors especials',
        SponsorDescription: 'Gestiona l’ordre, l’estat i el logotip sense publicar una nova versió del web.',
        SelectYear: 'Selecciona un any', SelectCategory: 'Selecciona una categoria',
        Sketches: 'Esbossos', Llibrets: 'Llibrets', Awards: 'Premis',
        PresidentInfantil: 'President Infantil', FalleraMayorInfantil: 'Fallera Major Infantil',
        Major: 'Major', Infant: 'Infantil', Link: 'Enllaç', Order: 'Ordre', Type: 'Tipus', Active: 'Actiu', Inactive: 'Inactiu',
        CurrentImage: 'Imatge actual', NoImage: 'Sense imatge', AddImage: 'Afegir imatge', ChangeImage: 'Canviar imatge', ReplaceImage: 'Reemplaçar imatge',
        EditData: 'Editar dades', Save: 'Guardar', Cancel: 'Cancel·lar', Remove: 'Llevar', MoveUp: 'Pujar', MoveDown: 'Baixar',
        AddSponsor: 'Afegir patrocinador o col·laborador', MainSponsor: 'Patrocinador principal', SpecialCollaborator: 'Col·laborador especial',
        Loading: 'Carregant…', Saving: 'Guardant…', Saved: 'Canvis guardats.', EmptyContent: 'No hi ha contingut per a este any.',
        SelectImage: 'Selecciona una imatge', ImagePreview: 'Vista prèvia de la imatge seleccionada',
        DetachTitle: 'Llevar imatge del contingut', DetachMessage: 'Esta imatge deixarà d’aparéixer, però l’arxiu original es conservarà.',
        ReplaceTitle: 'Confirmar reemplaçament', ReplaceMessage: 'La nova imatge es mostrarà en guardar. L’arxiu anterior es conservarà.',
        Confirm: 'Confirmar', AwardsText: 'Premis i reconeixements', AddAwardImage: 'Afegir imatge de premis',
        LlibretUrl: 'Enllaç del llibret', PhotoDescription: 'Descripció',
        Map: 'Mapa', InstagramVideo: 'Vídeo d’Instagram', InstagramPost: 'Publicació d’Instagram',
        FaqTitle: 'Preguntes freqüents', FaqQuestion1: 'Què és una falla?', FaqAnswer1: 'Una falla és una associació cultural que manté vives les tradicions valencianes i organitza activitats durant tot l’any.',
        FaqQuestion2: 'Com em puc apuntar a la falla?', FaqAnswer2: 'Pots acostar-te al casal faller i preguntar per la disponibilitat per a unir-te a la comissió.',
        FaqQuestion3: 'És obligatori vestir-se en els actes?', FaqAnswer3: 'No és obligatori, encara que és recomanable per a mantindre viva la tradició.',
        FaqQuestion4: 'Es fan més actes a banda de les Falles?', FaqAnswer4: 'Sí. La comissió organitza activitats esportives i culturals durant tot l’any.',

        /*Editar Usuarios*/

        UpdateProfile: 'Actualitzar Perfil',
        ConfirmPassword: 'Confirmar Contrasenya',
        NewPassword: 'Nova Contrasenya',
        ChangePassword: 'Configura contrseña',

        EmailRequiredForPasswordChange: "Per a canviar la contrasenya, per favor ingressa el teu correu electrònic.",
        PasswordMismatch: "Les contrasenyes no coincideixen.",
        EmailRequired: "El correu electrònic és obligatori.",
        EmailMismatch: "El correu electrònic no coincideix.",
        ProfileUpdated: "Perfil actualitzat amb èxit.",
        ErrorUpdatingProfile: "Error en actualitzar el perfil.",
        UnexpectedError: "Error inesperat, si us plau torneu a provar-ho.",
        RewardsInstructions: "Per als socis i recompenses, han de separar-se amb una coma. Exemple: Pepe, Luis"

    }
};
